export const STARTING_TIME = 10;
export const EMERGENCY_BUFFER = 1000;
export const FIRE_THRESHOLD_RATIO = 1;
export const CASH_INTEREST_APY = 0.08;
export const CREDIT_CARD_RATE = 0.24;
export const SKILL_BUILD_COST = 650;
export const SYSTEMATIZE_COST = 1800;
export const SYSTEMATIZE_VALUE_GAIN = 2500;
export const MIN_EXPENSES_FLOOR = 600;
export const EXPENSE_CUT_RATIO = 0.06;
export const EXPENSE_CUT_CAP = 350;

export const FAMILY_KID_EXPENSE = 450;
export const FAMILY_MARRIAGE_EXPENSE = 250;
export const FAMILY_KID_TIME_MARRIED = 1.5;
export const FAMILY_KID_TIME_SINGLE = 3;

export const MIN_JOB_TIME = 1;

export const TOAST_DURATION_MS = 3200;
export const LOG_DISPLAY_LIMIT = 7;
export const SNAPSHOT_LOG_RECENT = 3;

export const EXIT_CARD_PROBABILITY = 0.14;
export const OPPORTUNITY_DRAW_THRESHOLD = 0.48;
export const DOODAD_DRAW_THRESHOLD = 0.78;
export const EXIT_MARKET_FACTOR_MIN = 0.75;
export const EXIT_MARKET_FACTOR_RANGE = 0.35;

export const ASSET_TERMINAL_BOOK_VALUE_RATIO = 0.12;
export const SKILL_INCOME_BUMP = 250;

// Marital strain — over-committed time and/or negative cash flow shifts
// the probability that the divorce and marriage cards land. Each strain
// factor (state.time === 0, monthlyCashFlow() < 0) shifts both:
// divorce becomes more likely, marriage becomes less likely.
export const DIVORCE_BASE_PROB = 0.4;
export const DIVORCE_STRAIN_BUMP = 0.3;
export const MARRIAGE_BASE_PROB = 1.0;
export const MARRIAGE_STRAIN_PENALTY = 0.4;
